import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import menuItems from "./data/data";
import Logo from "../../assets/img/main-logo-w.png";
import { IoAddOutline } from "react-icons/io5";
import { LuMinus } from "react-icons/lu";
import { IoMdAdd } from "react-icons/io";

import "./sidebar.scss";

export default function Sidebar({ userRole }) {
    const [submenusOpen, setSubmenusOpen] = useState({});
    const [isCollapsed, setIsCollapsed] = useState(false);
    const location = useLocation();

    const toggleSubmenu = (itemId) => {
        setSubmenusOpen({
            ...submenusOpen,
            [itemId]: !submenusOpen[itemId],
        });
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const isSubMenuActive = (subMenuItems) => {
        return subMenuItems?.some(
            (subItem) => subItem.path === location.pathname
        );
    };

    const renderSubMenu = (subMenuItems) => {
        return (
            <ul className="sidebar__submenu">
                {subMenuItems.map((subItem) => (
                    <li key={subItem.id} className="sidebar__submenu__item">
                        {subItem.hasSubMenu ? (
                            <div
                                className="sidebar__menu__item__link"
                                onClick={() => toggleSubmenu(subItem.id)}
                            >
                                {subItem.title}
                                {submenusOpen[subItem.id] ? (
                                    <span
                                        style={{
                                            fontSize: "16px",
                                            display: "flex",
                                        }}
                                    >
                                        <IoMdAdd size={24} />
                                    </span>
                                ) : (
                                    <span
                                        style={{
                                            fontSize: "16px",
                                            display: "flex",
                                        }}
                                    >
                                        <IoAddOutline />
                                    </span>
                                )}
                            </div>
                        ) : (
                            <NavLink
                                to={subItem.path}
                                className={({ isActive }) =>
                                    isActive
                                        ? "sidebar__submenu__item__link active"
                                        : "sidebar__submenu__item__link"
                                }
                            >
                                {subItem.title}
                            </NavLink>
                        )}
                        {subItem.hasSubMenu &&
                            submenusOpen[subItem.id] &&
                            renderSubMenu(subItem.subMenuItems)}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
            <ul className="sidebar__menu">
                {menuItems.map(
                    (item) =>
                        (item.title !== "Panel de Administrador" ||
                            userRole === "Admin") && (
                            <li
                                key={item.id}
                                className={`sidebar__menu__item ${
                                    isSubMenuActive(item.subMenuItems)
                                        ? "active"
                                        : ""
                                } ${
                                    item.isSeparatedGroup
                                        ? "sidebar__menu__item--separated"
                                        : ""
                                }`}
                            >
                                {item.hasSubMenu ? (
                                    <div
                                        className={`sidebar__menu__item__link ${
                                            isSubMenuActive(item.subMenuItems)
                                                ? "active"
                                                : ""
                                        }`}
                                        onClick={() => toggleSubmenu(item.id)}
                                    >
                                        {item.title}
                                        {submenusOpen[item.id] ? (
                                            <span>
                                                <LuMinus />
                                            </span>
                                        ) : (
                                            <span>
                                                <IoMdAdd />
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    <NavLink
                                        to={item.path}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "sidebar__menu__item__link active"
                                                : "sidebar__menu__item__link"
                                        }
                                    >
                                        {item.title}
                                    </NavLink>
                                )}
                                {item.hasSubMenu &&
                                    submenusOpen[item.id] &&
                                    renderSubMenu(item.subMenuItems)}
                            </li>
                        )
                )}
            </ul>
            {/* Botón para colapsar/expandir */}
            <div className="sidebar__footer">
                <button
                    className="sidebar__toggle"
                    onClick={toggleSidebar}
                    aria-label={
                        isCollapsed ? "Expand sidebar" : "Collapse sidebar"
                    }
                >
                    {isCollapsed ? (
                        <MdKeyboardArrowRight
                            size={28}
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        />
                    ) : (
                        <MdKeyboardArrowLeft
                            size={28}
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        />
                    )}
                </button>
            </div>
        </aside>
    );
}
